import { VehicleOptionName, VehicleOptionType } from '../../../../api-client/enums'
import OptionButton from './option-button'

const vehicleOptions = [
  {
    label: 'Comfort',
    optionType: VehicleOptionType.Comfort,
    children: [
      { label: 'Air Conditioning', optionName: VehicleOptionName.AirCondition },
      { label: 'Sun / Moonroof', optionName: VehicleOptionName.SunMoonRoof },
      { label: 'Tilt Steering', optionName: VehicleOptionName.TiltSteering },
      { label: 'Heated / Cooled Seats', optionName: VehicleOptionName.HeatedCooledSeats },
    ],
  },
  {
    label: 'Convenience',
    optionType: VehicleOptionType.Convenience,
    children: [
      { label: 'Cruise Control', optionName: VehicleOptionName.CruiseControl },
      { label: 'Auto Headlights', optionName: VehicleOptionName.AutoHeadlights },
      { label: 'Push Button Start', optionName: VehicleOptionName.PushButtonStart },
      { label: 'Proximity Key', optionName: VehicleOptionName.ProximityKey },
      { label: 'Keyless Entry', optionName: VehicleOptionName.KeylessEntry },
      { label: 'Steering Controls', optionName: VehicleOptionName.SteeringControls },
    ],
  },
  {
    label: 'Exterior',
    optionType: VehicleOptionType.Exterior,
    children: [
      { label: 'Alloy Wheels', optionName: VehicleOptionName.AlloyWheels },
      { label: 'Tint', optionName: VehicleOptionName.Tint },
      { label: 'Trailer Hitch', optionName: VehicleOptionName.TrailerHitch },
      { label: 'Winter Tires', optionName: VehicleOptionName.WinterTires },
      { label: 'Spoiler', optionName: VehicleOptionName.Spoiler },
    ],
  },
  {
    label: 'Media & Communication',
    optionType: VehicleOptionType.MediaCommunication,
    children: [
      { label: 'CD Player', optionName: VehicleOptionName.CDPlayer },
      { label: 'Android Auto', optionName: VehicleOptionName.AndroidAuto },
      { label: 'Apple CarPlay', optionName: VehicleOptionName.AppleCarPlay },
      { label: 'Bluetooth', optionName: VehicleOptionName.Bluetooth },
      { label: 'DVD / Entertainment', optionName: VehicleOptionName.DvdEntertainment },
      { label: 'GPS / Navigation', optionName: VehicleOptionName.GPSNavigation },
      { label: 'Premium Sound', optionName: VehicleOptionName.PremiumSound },
      { label: 'Sirius / XM', optionName: VehicleOptionName.SiriusXM },
    ],
  },
  {
    label: 'Power',
    optionType: VehicleOptionType.Power,
    children: [
      { label: 'Power Locks', optionName: VehicleOptionName.PowerLocks },
      { label: 'Power Mirrors', optionName: VehicleOptionName.PowerMirrors },
      { label: 'Power Seats', optionName: VehicleOptionName.PowerSeats },
      { label: 'Power Doors', optionName: VehicleOptionName.PowerDoors },
      { label: 'Power Trunk', optionName: VehicleOptionName.PowerTrunk },
    ],
  },
  {
    label: 'Safety and security',
    optionType: VehicleOptionType.SafetyAndSecurity,
    children: [
      { label: 'ABS Brakes', optionName: VehicleOptionName.ABSBrakes },
      { label: 'Anti-theft / Security', optionName: VehicleOptionName.AntiTheftSecurity },
      { label: 'Backup Camera', optionName: VehicleOptionName.BackupCamera },
      { label: 'Backup Sensors', optionName: VehicleOptionName.BackupSensors },
      { label: 'Fog Lights', optionName: VehicleOptionName.FogLights },
      { label: 'Heated Mirrors', optionName: VehicleOptionName.HeatedMirrors },
      { label: 'Traction Control', optionName: VehicleOptionName.TractionControl },
      { label: 'Lane Departure', optionName: VehicleOptionName.LaneDeparture },
      { label: 'Tire Pressure Monitoring', optionName: VehicleOptionName.TPMS },
    ],
  },
]

export default function FeatureFilter({ selectedFeatures, onSelect }) {
  return (
    <div className='wrapper'>
      <div className='categoriesContainer flex flexWrap justifyBetween'>
        {vehicleOptions.map(({ label, optionType, children }) => (
          <div key={optionType} className='filterCategory'>
            <p className='categoryLabel'>{label}</p>
            <ul className='featureList flex flexWrap'>
              {children.map((child) => (
                <OptionButton
                  key={child.optionName}
                  name={child.optionName}
                  selected={!!selectedFeatures[child.optionName]}
                  onSelect={onSelect}
                >
                  {child.label}
                </OptionButton>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <style jsx>{`
        .wrapper {
          padding: 2rem;
          border-radius: 1rem;
          background: #fff;
          box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.16);
          color: var(--secondary-text-color);
        }

        .categoriesContainer {
          width: 100%;
          height: 50rem;
          overflow: auto;
        }

        .categoryLabel {
          margin: 0 0 1.8rem;
          font-size: 1.6rem;
          font-weight: 700;
        }

        .filterCategory {
          max-width: 39.8rem;
          width: 100%;
        }

        .featureList {
          :global(button) {
            width: 18.8rem;
            margin: 0 0 1.3rem;
          }

          :global(button:nth-child(odd)) {
            margin: 0 2.1rem 1.3rem 0;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            padding: 0;
            box-shadow: none;
          }

          .categoriesContainer {
            display: block;
          }

          .filterCategory {
            max-width: 100%;
            margin: 0 0 1rem;
          }

          .categoryLabel {
            font-size: 1.2rem;
          }

          .featureList {
            :global(button) {
              width: calc(50% - 1.3rem);
            }
          }
        }
      `}</style>
    </div>
  )
}
